export default __webpack_public_path__ + "static/media/Add_New.e3a192e4.svg";